import React from 'react';
import Footer from '../components/Footer';
import { SlideLayoutProps } from '../types';
import '../styles/SlideLayout.css';

const SlideLayout: React.FC<SlideLayoutProps> = ({
  children,
  footer,
  backgroundColor = '#ffffff',
  className = ''
}) => {
  return (
    <div className="slide-outer-frame">
      <div
        className={`slide-container ${className}`}
        style={{ backgroundColor }}
      >
        <div className="slide-content">
          {children}
        </div>
        {footer && <Footer {...footer} />}
      </div>
    </div>
  );
};

export default SlideLayout;
